import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  ResponseSuccess,
  ResponseErrorWithHandled,
} from '../../../../shared/types';

import {
  getDoNotCallLists,
  createDoNotCallList,
  updateDoNotCallList,
  deleteDoNotCallList,
  getDoNotCallListDetails,
  addPhoneNumber,
  deletePhoneNumbers,
  bulkDeletePhoneNumbers,
  exportDoNotCallList,
  importPhoneNumbersViaCsv,
} from '../../helpers/do-not-call.api';

import {
  GetDoNotCallListsPayload,
  CreateDoNotCallListPayload,
  UpdateDoNotCallListPayload,
  GetDoNotCallListDetailsPayload,
  AddPhoneNumberPayload,
  DeletePhoneNumbersPayload,
  BulkDeletePhoneNumbersPayload,
  ExportDoNotCallListPayload,
  ImportPhoneNumbersViaCsvPayload,
} from '../../types/do-not-call-list';

export const getDoNotCallListsRequest = createAsyncThunk<
  ResponseSuccess,
  GetDoNotCallListsPayload,
  { rejectValue: ResponseErrorWithHandled }
>('callDnc/getDoNotCallLists', async (payload, thunkAPI) => {
  try {
    return await getDoNotCallLists(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const createDoNotCallListRequest = createAsyncThunk<
  ResponseSuccess,
  CreateDoNotCallListPayload,
  { rejectValue: ResponseErrorWithHandled }
>('callDnc/createDoNotCallList', async (payload, thunkAPI) => {
  try {
    return await createDoNotCallList(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const updateDoNotCallListRequest = createAsyncThunk<
  ResponseSuccess,
  UpdateDoNotCallListPayload,
  { rejectValue: ResponseErrorWithHandled }
>('callDnc/updateDoNotCallList', async (payload, thunkAPI) => {
  try {
    return await updateDoNotCallList(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const deleteDoNotCallListRequest = createAsyncThunk<
  ResponseSuccess,
  string,
  { rejectValue: ResponseErrorWithHandled }
>('callDnc/deleteDoNotCallList', async (payload, thunkAPI) => {
  try {
    return await deleteDoNotCallList(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const getDoNotCallListDetailsRequest = createAsyncThunk<
  ResponseSuccess,
  GetDoNotCallListDetailsPayload,
  { rejectValue: ResponseErrorWithHandled }
>('callDnc/getDoNotCallListDetails', async (payload, thunkAPI) => {
  try {
    return await getDoNotCallListDetails(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const addPhoneNumberRequest = createAsyncThunk<
  ResponseSuccess,
  AddPhoneNumberPayload,
  { rejectValue: ResponseErrorWithHandled }
>('callDnc/addPhoneNumber', async (payload, thunkAPI) => {
  try {
    return await addPhoneNumber(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const deletePhoneNumbersRequest = createAsyncThunk<
  ResponseSuccess,
  DeletePhoneNumbersPayload,
  { rejectValue: ResponseErrorWithHandled }
>('callDnc/deletePhoneNumbers', async (payload, thunkAPI) => {
  try {
    return await deletePhoneNumbers(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const bulkDeletePhoneNumbersRequest = createAsyncThunk<
  ResponseSuccess,
  BulkDeletePhoneNumbersPayload,
  { rejectValue: ResponseErrorWithHandled }
>('callDnc/bulkDeletePhoneNumbers', async (payload, thunkAPI) => {
  try {
    return await bulkDeletePhoneNumbers(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const exportDoNotCallListRequest = createAsyncThunk<
  ResponseSuccess,
  ExportDoNotCallListPayload,
  { rejectValue: ResponseErrorWithHandled }
>('callDnc/exportDoNotCallList', async (payload, thunkAPI) => {
  try {
    return await exportDoNotCallList(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const importPhoneNumbersViaCsvRequest = createAsyncThunk<
  ResponseSuccess,
  ImportPhoneNumbersViaCsvPayload,
  { rejectValue: ResponseErrorWithHandled }
>('callDnc/importPhoneNumbersViaCsv', async (payload, thunkAPI) => {
  try {
    return await importPhoneNumbersViaCsv(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});
